/** BRS task payment attribute */
export enum TaskPaymentAttributeEnum {
  /** Select all tasks */
  ALL = 'ALL',
  /** Select tasks, where `credit_payment` = *true* */
  TRUE = 'TRUE',
  /** Select tasks, where `credit_payment` = *false* */
  FALSE = 'FALSE',
}
